import { render, staticRenderFns } from "./DailyMotionPlayer.vue?vue&type=template&id=61089929&scoped=true"
import script from "./DailyMotionPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./DailyMotionPlayer.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DailyMotionPlayer.vue?vue&type=style&index=0&id=61089929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61089929",
  null
  
)

export default component.exports